<template>
  <div class="tab-site">
    <Accordion :activeIndex="2">
      <AccordionTab header="Модули">
        <RolesEditorProjectsPolicies
          :data="dataSource?.Banner"
          title="Баннер"
        />
        <!-- <RolesEditorProjectsPolicies
          :data="dataSource?.Activities"
          title="Направления деятельности"
        /> -->

        <!-- <RolesEditorProjectsPolicies
          :data="dataSource?.Achievements"
          title="Достижения"
        /> -->
        <!-- <RolesEditorProjectsPolicies
          :data="dataSource?.WorkWithUs"
          title="Как с нами работать"
        /> -->
        <!-- <RolesEditorProjectsPolicies
          :data="dataSource?.Footer"
          title="Подвал"
        /> -->

        <RolesEditorProjectsPolicies
          :data="dataSource?.Regions"
          title="Регионы"
        />
        <!-- <RolesEditorProjectsPolicies
          :data="dataSource?.MassMedia"
          title="СМИ о нас"
        /> -->
        <RolesEditorProjectsPolicies
          :data="dataSource?.Materials"
          title="Материалы"
        />
      </AccordionTab>
      <AccordionTab header="Товары и Услуги">
        <RolesEditorProjectsPolicies
          :data="dataSource?.Products"
        />
      </AccordionTab>
      <AccordionTab header="Новости">
        <RolesEditorProjectsPolicies
          :data="dataSource?.Articles"
        />
      </AccordionTab>
      <!-- <AccordionTab header="Мероприятия">
          <p>
            Даный функционал еще не внедрён
          </p>
      </AccordionTab> -->
    </Accordion>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

import RolesEditorProjectsPolicies from '@/components/elements/RolesEditorProjectsPolicies.vue'

import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'

export default {
  name: 'RolesEditorProjectsSite',
  components: {
    Accordion,
    AccordionTab,
    RolesEditorProjectsPolicies
  },
  setup () {
    const store = useStore()

    const dataSource = computed(() => {
      return store.getters.getUserForm?.UserClaims?.Site
    })
    return {
      dataSource
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-site {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
:deep(.p-accordion-header-link, .p-accordion-header-action) {
  background-color: #F5F5F5 !important;
  border: 1px solid #C8C8C8 !important;
  border-radius: 6px;
}
:deep(.p-accordion .p-accordion-tab) {
  margin-bottom: 8px;
}
</style>
